// FWurfData.js
export const FWurfData = {
    Feamara: {
        label: 'Feamára',
        data: [
            0.423, 0.467, 0.525, 0.615, 0.698, 0.780, 0.835,
            0.952, 1.022, 1.046, 1.100, 1.153, 1.235, 1.300,
            1.410, 1.470, 1.500, 1.540, 1.720, 1.760, 1.860,
            1.950, 2.030, 2.190, 2.280, 2.420, 2.500, 2.640,
            2.810, 2.930, 3.060, 3.180, 3.330, 3.420, 3.570,
            3.800, 3.960
        ],
        borderColor: 'rgba(255, 0, 0, 1)',
        backgroundColor: 'rgba(255, 0, 0, 0.2)',
        sex: 'female'
    },
    Feanor: {
        label: 'Fëanor',
        data: [
            0.511, 0.570, 0.615, 0.720, 0.805, 0.874, 0.958,
            1.083, 1.140, 1.242, 1.372, 1.396, 1.481, 1.560,
            1.670, 1.760, 1.850, 1.910, 2.040, 2.150, 2.250,
            2.380, 2.450, 2.640, 2.670, 2.780, 2.920, 3.120,
            3.220, 3.340, 3.480, 3.690, 3.800, 3.950, 4.230,
            4.440, 4.550
        ],
        borderColor: 'rgba(0, 0, 139, 1)',
        backgroundColor: 'rgba(0, 0, 139, 0.2)',
        sex: 'male'
    },
    FrodoFili: {
        label: 'Frodo Fíli',
        data: [
            0.260, 0.300, 0.340, 0.400, 0.452, 0.510, 0.581,
            0.674, 0.740, 0.827, 0.860, 0.968, 1.030, 1.060,
            1.130, 1.190, 1.240, 1.270, 1.400, 1.480, 1.590,
            1.700, 1.750, 1.880, 1.910, 2.050, 2.160, 2.320,
            2.470, 2.610, 2.710, 2.830, 2.960, 3.080, 3.260,
            3.440, 3.560
        ],
        borderColor: 'rgba(135, 206, 250, 1)',
        backgroundColor: 'rgba(135, 206, 250, 0.2)',
        sex: 'male'
    },
    Faramir: {
        label: 'Faramir',
        data: [
            0.370, 0.409, 0.455, 0.530, 0.595, 0.670, 0.745,
            0.838, 0.884, 0.946, 1.015, 1.073, 1.150, 1.220,
            1.310, 1.410, 1.440, 1.490, 1.580, 1.660, 1.780,
            1.860, 1.920, 2.050, 2.090, 2.250, 2.330, 2.550,
            2.650, 2.740, 2.890, 3.010, 3.080, 3.220, 3.420,
            3.510, 3.700
        ],
        borderColor: 'rgba(255, 255, 0, 1)',
        backgroundColor: 'rgba(255, 255, 0, 0.2)',
        sex: 'male'
    }
};

export const milestones = [
    { date: new Date(2025, 0, 5), label: ['Alle Welpen haben ihre ersten Schritte gemacht.'] },
    { date: new Date(2025, 0, 9), label: ['Alle Welpen konnten eigenständig ihren Kopf halten.', 'Frodo Fíli, Faramir und Fëanor haben ihre Augen geöffnet.'] },
    { date: new Date(2025, 0, 10), label: ['Feamára hat ihre Augen geöffnet.', 'Alle Rüden haben auf Geräusche reagiert.'] },
    { date: new Date(2025, 0, 11), label: ['Feamára hat auf Geräusche reagiert.'] },
    { date: new Date(2025, 0, 12), label: ['Seit heute beginnen alle, ihre Umgebung intensiver zu erkunden.', 'Dabei probieren sie alles aus und beißen neugierig in ihre Mama oder ihre Geschwister.'] },
    { date: new Date(2025, 0, 16), label: ['Induktion der spontan kontrollierten Miktion und Defäkation.'] },
    { date: new Date(2025, 0, 18), label: ['Bei allen Welpen sprießen die ersten Zähne durch.', 'Beginnende Exploration (Interesse an Umwelt außerhalb der Wurfbox) ...'] },
    { date: new Date(2025, 0, 20), label: ['... bis zum selbstständigen Verlassen der Wurfkiste (von Allen).', 'Beginnendes Interesse an Zufütternahrung.'] },
    { date: new Date(2025, 0, 27), label: ['Fëanors Ohren stehen nun aufrecht.'] },
    { date: new Date(2025, 0, 29), label: ['Auch Faramirs Ohren haben sich aufgerichtet.'] },
    { date: new Date(2025, 0, 31), label: ['Nun stehen auch Frodo Fílis Ohren.'] },
];

// const sollNiedrigM = [13.1, 14.6, 17.7, 20.4, 22.8, 24.8, 26.4, 27.6, 28.5, 29.2, 29.9, 30.2, 30.5, 30.6, 30.8, 31.0, 31.0];
// const sollHochM = [14.4, 15.6, 18.9, 21.9, 24.7, 26.9, 28.8, 30.3, 31.4, 32.3, 32.9, 33.5, 33.9, 34.2, 34.4, 34.6, 34.8];
// const sollNiedrigW = [11.4, 12.6, 15.3, 17.6, 19.7, 21.3, 22.6, 23.6, 24.3, 24.7, 25.2, 25.5, 25.7, 25.8, 25.9, 25.9, 25.8];
// const sollHochW = [12.7, 13.6, 16.6, 19.3, 21.7, 23.5, 25.0, 26.2, 27.1, 27.8, 28.3, 28.7, 28.9, 29.2, 29.3, 29.4, 29.5];
